import React from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { experiences } from '../constants';
import Footer from './Footer';

const Experience = () => {
  return (
    <div className="experience bg-black w-screen text-white min-h-screen flex flex-col overflow-x-hidden">
      
      <div className="pt-20 sm:px-16">
        <h2 className="text-4xl sm:text-5xl font-extrabold mt-4">
          Work Experience.
        </h2>
      </div>


      <div className="flex-grow mt-8">
        <VerticalTimeline>
          {experiences.map((experience) => (
            <VerticalTimelineElement
              key={experience.company}
              className="relative vertical-timeline-element--work"
              contentStyle={{ background: "#1d1836", color: "#fff" }}
              contentArrowStyle={{ borderRight: "7px solid #232631" }}
              date={experience.duration}
              iconStyle={{ background: '#fff' }}
              icon={
                <a
                  className="flex justify-center items-center w-full h-full"
                  href={experience.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={experience.logo}
                    alt={experience.company}
                    className="w-[60%] h-[60%] object-contain"
                  />
                </a>
              }
            >
              <div>
                <h3 className="text-white text-[24px] font-bold">{experience.role}</h3>
                <p
                  className="text-secondary text-[16px] font-semibold"
                  style={{ margin: 0 }}
                >
                  {experience.company}
                </p>
              </div>

              <ul className="mt-5 list-disc ml-5 space-y-2">
                {experience.points.map((point, index) => (
                  <li
                    key={`experience-point-${index}`}
                    className="text-white-100 text-[14px] pl-1 tracking-wider"
                  >
                    {point}
                  </li>
                ))}
              </ul>
            </VerticalTimelineElement>
          ))}
        </VerticalTimeline>
      </div>

      
      <div className="mt-auto">
        <Footer />
      </div>
    </div>
  );
};

export default Experience;
